// extracted by mini-css-extract-plugin
export default {"border":"proshow_border__VDTtZ","imageBox":"proshow_imageBox__83dGw","textBox":"proshow_textBox__8rvx+"};